import { get } from 'api/api';

export const FETCH_NEEDS_ASSESSMENT_RESULTS = 'FETCH_NEEDS_ASSESSMENT_RESULTS';
export const FETCH_NEEDS_ASSESSMENT_RESULTS_SUCCESS = 'FETCH_NEEDS_ASSESSMENT_RESULTS_SUCCESS';
export const FETCH_NEEDS_ASSESSMENT_RESULTS_ERROR = 'FETCH_NEEDS_ASSESSMENT_RESULTS_ERROR';

export const fetchCommunityResults = (communityId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_NEEDS_ASSESSMENT_RESULTS });

    try {
      const { data } = await get(`/private/needs-assessment/community/${communityId}`);
      return dispatch({
        type: FETCH_NEEDS_ASSESSMENT_RESULTS_SUCCESS,
        results: data,
        selectedCommunityId: communityId,
      });
    } catch (error) {
      return dispatch({
        type: FETCH_NEEDS_ASSESSMENT_RESULTS_ERROR,
        error,
      });
    }
  };
};



// WEBPACK FOOTER //
// ./app/assets/flux/actions/needsAssessmentActions.js